import { initializeApp } from 'firebase/app'
import { getAuth, setPersistence, browserLocalPersistence, connectAuthEmulator } from 'firebase/auth'
import { config } from '@/config'
import { logUnexpectedFailure } from '@/utils/errorHandling'

const firebaseConfig = {
  apiKey: config.firebaseApiKey,
  // Mobile SSO uses signInWithRedirect, whose OAuth handler must be served from the
  // same origin as the app. When authDomain is the default *.firebaseapp.com (a
  // different site), browsers that partition third-party storage (Safari/iOS ITP,
  // modern Chrome) silently drop the redirect result and the user bounces back to
  // login with no error (#2493). nginx proxies /__/auth/ and /__/firebase/ to the
  // Firebase handler, so we point authDomain at the current host to keep the auth
  // flow first-party. This is also correct for the multi-subdomain deployment
  // (app./mijn./admin.scrivio.nl share one image) — each lands on its own origin.
  // The emulator overrides the handler via connectAuthEmulator, so it keeps the
  // configured value for E2E/dev.
  authDomain: config.useFirebaseEmulator ? config.firebaseAuthDomain : window.location.hostname,
  projectId: config.firebaseProjectId,
  storageBucket: config.firebaseStorageBucket,
  messagingSenderId: config.firebaseMessagingSenderId,
  appId: config.firebaseAppId,
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

// Connect to Firebase Auth Emulator in E2E testing mode
if (config.useFirebaseEmulator) {
  connectAuthEmulator(auth, config.firebaseEmulatorUrl, { disableWarnings: true })
  console.log('Firebase Auth connected to emulator:', config.firebaseEmulatorUrl)
}

// Set persistence to local (keeps user logged in across sessions)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  logUnexpectedFailure('Failed to set auth persistence:', error)
})
